import React, {Component} from 'react'
import CSSModules from 'react-css-modules'
import styles from './inputProfile.css'
const style = {
  color: '#f97b7c',
  fontSize: '12px',
  position: 'absolute',
  left: '0',
  bottom: '-20px'
}

const iconsName = [
  'ico-book',
  'ico-flag',
  'ico-price',
  'ico-rocket'
]
class InputProfile extends Component {

  state = {
    value :''
  }

  componentDidMount(){
    const {val} = this.props
    console.log('didd')
    console.log(this.props)
    console.log(val)
    this.setState({
      value: val || this.props.input.value
    })
  }

  componentWillReceiveProps(nextProps){
    console.log('cwrp')
    if(nextProps.val !== this.props.val){
      console.log('cwrp2')
      console.log(nextProps)
      console.log(this.props)
      this.setState({
        value: nextProps.val
      })
      this.props.input.onChange(nextProps.val)
    }
  }

  onClickIcon(icon) {
    const { input } = this.props
       input.onChange(icon)
  }

  onChange(e){
    console.log('onChh')
    console.log(e.target.value)
    this.setState({
      value: e.target.value
    })
    this.props.input.onChange(e.target.value)
  }

  render() {
    const { input, notReq, placeholder, disabled, notice, type, meta: { touched, error } } = this.props
    //console.log(this.props)
    //console.log('fffiled')
    const icons = iconsName.map(icon => {
      return (
        <div key={icon} onClick={this.onClickIcon.bind(this, icon)} className={styles.iconBoxItem}>
          <svg className={'svg-icon'}>
            <use xlinkHref={'#' + icon}/>
          </svg>
        </div>
      )
    })

    return (

      <div className={styles.inputBox}>
        {input.name === 'customIcon' ? <div className={styles.iconBox}>{icons}</div> : ''}

        <input {...input}
          disabled={disabled}
          type={type || 'text'}
           value = {this.state.value}
           onChange={this.onChange.bind(this)}
          placeholder={placeholder}
          className={!notReq && touched && error ? styles.inputFieldError : (notice ? styles.inputFieldNotice :styles.inputField)}
          onFocus={e => {
          e.target.placeholder = ''
        }} onBlur={e => {
          e.target.placeholder = placeholder
        }}/>
        {!notReq && touched && !error && <span className={styles.inputIcoRequiredSucceess}></span>}
        {!notReq && touched && error && <span className={styles.inputIcoRequired}></span>}
        {!notReq && touched && error && <span style={style}>{error}</span>}
      </div>
    )
  }
}
export default CSSModules(InputProfile, styles)



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/components/componentKit/InputProfile.js